import { Cropr } from "../utils/legacy";
import React from "react";

type GeometryPartPreviewProps = {
  overlays: string[];
  geometry: string;
  class?: string;
  size?: number;
  dimensions?: boolean;
  baseStyle?: any;
  overlayStyle?: any;
};

function GeometryPartPreview({ geometry, overlays, ...options }: GeometryPartPreviewProps) {
  const {
    size = 75,
    dimensions = true,
    baseStyle = { fill: "#999", stroke: "#333" },
    overlayStyle = {
      fill: "#f93",
      stroke: "#000",
      opacity: 0.6,
      strokeDasharray: "10 5",
    },
  } = options;
  const props = dimensions ? { height: size, width: size } : {};
  const extent = Cropr.getExtent(Cropr.parsePolygons(geometry)[0]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      {...props}
      viewBox={`0 0 ${size} ${size}`}
      className={options["class"] || ""}
    >
      <path
        d={Cropr.getSVGPath(geometry, size, size * 0.8, extent)}
        {...baseStyle}
        strokeWidth="2"
        fillRule="evenodd"
      />
      {overlays.map((overlay, index) => (
        <path
          key={index}
          d={Cropr.getSVGPath(overlay, size, size * 0.8, extent)}
          {...overlayStyle}
          strokeWidth="2"
          fillRule="evenodd"
        />
      ))}
    </svg>
  );
}

export default GeometryPartPreview;
